// Service Management isn't released yet; flip to true to show it on roles.
export const SERVICE_MANAGEMENT_ENABLED = false;

// Role module tabs, keyed to the license availability block that gates each.
const ROLE_MODULE_TABS = [
  { key: "time", label: "Time Entry", licenseKey: "time" },
  { key: "expense", label: "Expense", licenseKey: "expenses" },
  {
    key: "project",
    label: "Project Management",
    licenseKey: "projectManagement",
  },
  {
    key: "service",
    label: "Service Management",
    licenseKey: "serviceManagement",
  },
];

// Tabs for modules with at least 1 licensed seat; all tabs until licenses load.
export function getLicensedRoleTabs(licenses) {
  const tabs = ROLE_MODULE_TABS.filter(
    (t) => t.key !== "service" || SERVICE_MANAGEMENT_ENABLED
  );
  const loaded = licenses?.lastFetched && !licenses?.error && licenses?.data;
  if (!loaded) return tabs;
  return tabs.filter((t) => (licenses.data[t.licenseKey]?.limit || 0) > 0);
}

export function buildRoleFingerprint(role) {
  const payTypesSorted = {};
  if (role.payTypeOptions) {
    Object.keys(role.payTypeOptions)
      .sort()
      .forEach((key) => {
        payTypesSorted[key] = role.payTypeOptions[key];
      });
  }
  return JSON.stringify({
    name: role.name,
    description: role.description || null,
    enableTime: role.enableTime || false,
    enableExpense: role.enableExpense || false,
    enableProjectManagement: role.enableProjectManagement || false,
    enableServiceManagement: role.enableServiceManagement || false,
    enableJobLocationEditing: role.enableJobLocationEditing || false,
    enableAdministration: role.enableAdministration || false,
    adminViewLicenses: role.adminViewLicenses || false,
    adminConfigureAccessGroups: role.adminConfigureAccessGroups || false,
    adminConfigureApprovalGroups: role.adminConfigureApprovalGroups || false,
    adminConfigureRoles: role.adminConfigureRoles || false,
    adminConfigureUsers: role.adminConfigureUsers || false,
    allowMultipleEmployeeEntries: role.allowMultipleEmployeeEntries || false,
    allowSigningOtherEmployees: role.allowSigningOtherEmployees || false,
    allowCrewSetup: role.allowCrewSetup || false,
    showMyEmployeesWeeklySummary: role.showMyEmployeesWeeklySummary || false,
    showMyEmployeesWorkerClass: role.showMyEmployeesWorkerClass || false,
    allowApprovals: role.allowApprovals || false,
    allowAbsenceEntries: role.allowAbsenceEntries || false,
    viewAndSignOnly: role.viewAndSignOnly || false,
    showPayType: role.showPayType || false,
    payTypeOptions: payTypesSorted,
    requireTimer: role.requireTimer || false,
    requireJob: role.requireJob || false,
    showWorkersClass: role.showWorkersClass || false,
    showDepartment: role.showDepartment || false,
    showWorkLocation: role.showWorkLocation || false,
    showEquipment: role.showEquipment || false,
    showUnits: role.showUnits || false,
    timerAlertMinutes: role.timerAlertMinutes || 0,
    hoursAlertHours: role.hoursAlertHours || 0,
    allowFieldLogs: role.allowFieldLogs || false,
  });
}

export function groupRoles(roles, companiesMap) {
  const groups = new Map();
  roles.forEach((role) => {
    const fingerprint = buildRoleFingerprint(role);
    if (!groups.has(fingerprint)) groups.set(fingerprint, []);
    groups.get(fingerprint).push(role);
  });

  return Array.from(groups.values()).map((group) => {
    const companyUuids = group.map((r) => r.company_uuid).filter(Boolean);
    const companyNames = companyUuids.map(
      (uuid) => companiesMap[uuid] || uuid.slice(0, 8) + "\u2026"
    );
    return {
      ...group[0],
      uuids: group.map((r) => r.uuid),
      companyUuids,
      companyNames,
      totalUsers: group.reduce((s, r) => s + (r.totalUsers || 0), 0),
      activeUsers: group.reduce((s, r) => s + (r.activeUsers || 0), 0),
    };
  });
}
